/* eslint-disable no-unused-vars */
export enum POOLSTATUS {
  WAIT, // 대기
  ING, // 진행중
  DONE, // 종료
  DELETE, // 삭제
  REGIST, // 등록 (대기 이전 시간에 등록 한 경우)
}

export enum STATE_STAKE {
  STAKE = 'stake',
  UNSTAKE = 'unstake',
  CLAIM = 'claim',
  WITHDRAW = 'withdraw',
  PENDING = 'pending', // 해당기능은 없지만 팬딩 트랜잭션 상태일 때 다시 시도 할 수 있도록 기능 추가
}
